import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { CssVarsProvider } from '@mui/joy/styles';
import { CssBaseline } from '@mui/joy';
import '@fontsource/inter';
import '@fontsource/caveat';
import '@fontsource/source-sans-pro';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  Outlet
} from 'react-router-dom';

import './modules/firebase';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import Settings from './components/Settings';
import Chat from './components/Chat';
import { UserProvider } from './context/user';

const App = () => {
  return (
    <CssVarsProvider defaultMode="system">
      <CssBaseline />
      <UserProvider>
        <Outlet />
      </UserProvider>
    </CssVarsProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <LandingPage />
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
        children: [
          { index: true, element: <Navigate to="chat" replace /> },
          {
            path: 'chat',
            element: <Chat />
          },
          {
            path: 'settings',
            element: <Settings />
          }
        ]
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
